import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-trip-traveler-list',
  templateUrl: './trip-traveler-list.component.html',
  styleUrls: ['./trip-traveler-list.component.css']
})
export class TripTravelerListComponent implements OnInit {

  private dp = [];
  displayedColumns = ['sr', 'member_id', 'invoice_no', 'customer_name', 'mobile', 'national_id', 
    'passport_no', 'date_of_birth', 'gender', 'depend_count', 'reference'];
  // displayedColumns2 = ['sr', 'member_id', 'invoice_no', 'customer_name', 'mobile', 'national_id', 
  //   'passport_no', 'date_of_birth', 'gender', 'depend_count', 'faqih_name'];
  // , 'age'

  model = { 'title': 'قائمة المسجلين على برنامج' };

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  id;
  trip_name = '';
  trip_number = '';
  departure_date = '';
  arrival_date = '';
  total_registered = 0;
  trip_info = [];

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private route: ActivatedRoute, private router: Router,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  Registered_List; Prog_Name; Prog_No;
  Departure_Date; Return_Date; Total_Registered;

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Registered_List').subscribe((res: string) => {
      this.Registered_List = res;
    });
    this.model['title'] = this.Registered_List;

    translate.get('Prog_Name').subscribe((res: string) => {
      this.Prog_Name = res;
    });

    translate.get('Prog_No').subscribe((res: string) => {
      this.Prog_No = res;
    });

    translate.get('Departure_Date').subscribe((res: string) => {
      this.Departure_Date = res;
    });

    translate.get('Return_Date').subscribe((res: string) => {
      this.Return_Date = res;
    });

    translate.get('Total_Registered').subscribe((res: string) => {
      this.Total_Registered = res;
    });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['id'] != undefined) {
        this.id = params['id'];
        let obj;

        let query = "SELECT `trip`.* FROM `trip` WHERE `trip`.`trip_id` = '" + this.id + 
          "' AND `trip`.`status` = '1'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            this.trip_info = data.data['list'];

            this.trip_name = this.trip_info['0']['trip_name'];
            this.trip_number = this.trip_info['0']['trip_number'];
            this.departure_date = this.trip_info['0']['departure_date'];
            this.arrival_date = this.trip_info['0']['arrival_date'];

            obj = { cmd: 'getTripRegRep', 'trip_id': this.id };
            if (this.applicationConstants.user_info['user_id'] == undefined)
              obj['agent_acct_number'] = this.applicationConstants.user_info['acct_number'];

            this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                this.dp = data.data['list'][0]['traveler_list'];
                this.dataSource = new MatTableDataSource(this.dp);
                this.dataSource.sort = this.sort;
                this.total_registered = data.data['list'][0]['total_registered'];
              });
          });
      }

    });
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Registered_List + '</td></tr>';
    html_data += '<tr><td width="33%"> ' + this.Prog_Name + ': ' + this.trip_name + '</td><td width="33%"> ' +
      this.Prog_No + ': ' + this.trip_number + '</td></tr>';
    html_data += '<tr><td width="33%"> ' + this.Departure_Date + ': ' + this.departure_date + '</td><td width="33%"> ' +
      this.Return_Date + ': ' + this.arrival_date + '</td></tr>';
    html_data += '<tr><td width="33%"> ' + this.Total_Registered + ' ' + this.total_registered + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('prog_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
